<section class="order-container" id="mplvolumenoculto-order">
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Títulos</div>
      </div>
      <div class="right parcialidad">
        <div class="title-name">Parcialidad</div>
      </div>
    </div>
    <div
      class="titulos"
      [placeholder]="'Títulos'"
      [isTitles]="true"
      punchPicker
      (items)="setTitles($event)"
      [sentValue]="titles"
      [minValue]="minTitles"
      data-recording-ignore="mask"
    ></div>
    <div
      class="parcialidad"
      [stepsIncrement]="5"
      [maxValue]="95"
      [placeholder]="'Parcialidad'"
      [minValue]="0"
      punchPicker
      [isPercentage]="true"
      (items)="setPartial($event)"
    ></div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name">Puja</div>
      </div>
      <div class="right max-price">
        <div class="title-name">Precio Máximo</div>
      </div>
    </div>
    <div
      class="puja"
      [placeholder]="'Puja'"
      punchPicker
      [maxValue]="900"
      [minValue]="1"
      (items)="setPuja($event)"
    ></div>
    <div
      class="prc-max"
      [sentValue]="selectedPrice"
      [placeholder]="'Prc. máximo'"
      punchPicker
      [isPrice]="true"
      (items)="setMaxPrice($event)"
      [minValue]="0"
      data-recording-ignore="mask"
    ></div>
  </div>
  <div class="row">
    <div class="row">
      <div class="left">
        <div class="title-name disabled">Duración</div>
      </div>
    </div>
    <div class="hard-section">
      <div class="subtitle">1 día</div>
    </div>
  </div>
  <div class="actions" *ngIf="canOperate && !isDiscretional">
    <button (click)="tryBuy()" class="btn-compra">
      <div class="button button--loading" *ngIf="isBuyButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isBuyButtonLoading ? '' : 'Comprar' }}
    </button>
    <button (click)="trySell()" class="btn-venta">
      <div class="button button--loading" *ngIf="isSellButtonLoading">
        <div class="button__loader">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
      {{ isSellButtonLoading ? '' : 'Vender' }}
    </button>
  </div>
</section>

<app-confirmation-modal
  [order]="confirmationOrder"
  (onClose)="cancelConfirmation()"
  (confirmationHandler)="registerOrder()"
  *ngIf="showConfirmation"
>
</app-confirmation-modal>
